import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OperationWithLocation, RotationCargoOperationVM } from 'src/utils/stowage/stowageOperation/operationFormatUtils';
import { OperationsTableCell, PortLink, BerthLink } from './OperationsForCargoPanel.styles';

interface PortBerthCellProps {
    item: OperationWithLocation;
    prevOperation: RotationCargoOperationVM | null;
    onPortClick: (portCallGuid: string) => void;
    onBerthClick: (portCallGuid: string, berthCallGuid: string) => void;
}

const PortBerthCell: React.FC<PortBerthCellProps> = ({ item, prevOperation, onPortClick, onBerthClick }) => {
    const operation = item.operation;
    const isTransit = operation.operationType === 'Transit';

    // Check if the current operation is at the same port as the previous operation
    const isSamePortAsPrevious = prevOperation && prevOperation.portCallGuid === operation.portCallGuid;

    const handlePortClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (operation.portCallGuid) {
            onPortClick(operation.portCallGuid);
        }
    };

    const handleBerthClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (operation.portCallGuid && operation.berthCallGuid) {
            onBerthClick(operation.portCallGuid, operation.berthCallGuid);
        }
    };

    // For transit operations, always show the port name since each transit entry is distinct
    // For loading/unloading, hide port if same as previous to avoid visual repetition
    const shouldShowPort = isTransit || !isSamePortAsPrevious;

    return (
        <OperationsTableCell>
            <div className="port-berth-container">
                {shouldShowPort && (
                    <div>
                        <PortLink href="#" onClick={handlePortClick} isTransit={isTransit}>
                            {item.portDisplayName}
                            {isTransit && ' (T)'}
                            <FontAwesomeIcon className="external-link-icon" icon="external-link-alt" />
                        </PortLink>
                    </div>
                )}
                {!isTransit && operation.berthCallGuid && (
                    <div className={isSamePortAsPrevious ? 'berth-only' : ''}>
                        <BerthLink href="#" onClick={handleBerthClick}>
                            {item.berthName}
                            <FontAwesomeIcon className="external-link-icon" icon="external-link-alt" />
                        </BerthLink>
                    </div>
                )}
            </div>
        </OperationsTableCell>
    );
};

export default PortBerthCell;
